import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { partnerProfessionDetailEditSchema } from '../../../ValidationSchema';
import { editPartnerprofessionalPreference, getAllIncome, getCity, getCountry, getEducation, getMultipleCity, getMultipleState, getOccupation, getState } from '../../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { Card, CardContent, CardHeader, MenuItem, TextField, Button, FormControl, InputLabel, Select, Chip, Autocomplete } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const PartnerEducationOccupationEdit = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const userProfileData = location.state?.userProfileData || {};
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [partnerEducation, setPartnerEducation] = useState([]);
  const [partnerOccupation, setPartnerOccupation] = useState([]);
  const [income, setIncome] = useState([]);
  const educationArray = userProfileData.partnerEducation_ids
    ? userProfileData.partnerEducation_ids.split(',').map((item) => item.trim())
    : [];

  const occupationArray = userProfileData.partnerOccupation_ids
    ? userProfileData.partnerOccupation_ids.split(',').map((item) => item.trim())
    : [];

  const residingCountryArray = userProfileData.partnercountrylivingids
    ? userProfileData.partnercountrylivingids.split(',').map((item) => item.trim())
    : [];

  const residingStateArray = userProfileData.partnerResidingStateids
    ? userProfileData.partnerResidingStateids.split(',').map((item) => item.trim())
    : [];

  const residingCityArray = userProfileData.partnerResidingCityids
    ? userProfileData.partnerResidingCityids.split(',').map((item) => item.trim())
    : [];

  const formik = useFormik({
    initialValues: {
      Partner_education: educationArray,
      partner_occupation: occupationArray,
      partnerIncome: userProfileData.partnerIncome || '',
      // partnerIncomeTo: userProfileData.partnerIncomeTo || '',
      partner_residingCountry: residingCountryArray,
      partner_residingState: residingStateArray,
      partner_residingCity: residingCityArray,
      user_id: localStorage.getItem('user'),
      // tokan: localStorage.getItem('token')
    },
    validationSchema: partnerProfessionDetailEditSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formattedValues = {
          ...values,
          Partner_education: values.Partner_education.join(','), // Convert back to string
          partner_occupation: values.partner_occupation.join(','), // Convert back to string
          partner_residingCountry: values.partner_residingCountry.join(','),
          partner_residingState: values.partner_residingState.join(','),
          partner_residingCity: values.partner_residingCity.join(','),
        };
        const response = await editPartnerprofessionalPreference(formattedValues);
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000); 
        } else {
          toast.error('Failed to update the Partner Education & Profession data');
        }
      } catch (error) {
        toast.error('Failed to update the Partner Education & Profession data');
      } finally {
        setSubmitting(false);
      }
    }
  });
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await getCountry();
        if (response.status === 200 || response.status === 201) {
          setCountries(response.data.data);
        }
      } catch (error) {
        toast.error(error);
      }
    };

    const fetchEducation = async () => {
      try {
        const response = await getEducation();
        if (response.status === 200 || response.status === 201) {
          setPartnerEducation(response.data.data);
        } else {
          toast.error('Failed to fetch education details');
        }
      } catch (error) {
        toast.error(error);
      }
    }

    const fetchOccupation = async () => {
      try {
        const response = await getOccupation();
        if (response.status === 200 || response.status === 201) {
          setPartnerOccupation(response.data.data);
        } else {
          toast.error('Failed to fetch occupation details');
        }
      } catch (error) {
        toast.error(error);
      }
    }

    const fetchIncome = async () => {
      try {
        const response = await getAllIncome();
        if (response.status === 200 || response.status === 201) {
          setIncome(response.data.data);
        } else {
          toast.error('Failed to fetch income details');
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
    fetchIncome()
    fetchEducation();
    fetchOccupation();
    fetchCountry();
  }, []);

  useEffect(() => {
    const fetchState = async () => {
      if (formik.values.partner_residingCountry.length > 0) {
        try {
          const response = await getMultipleState({ids:formik.values.partner_residingCountry});
          if (response.status === 200 || response.status === 201) {
            setStates(response.data);
          }
        } catch (error) {
          toast.error(error);
        }
      }
    };
    fetchState();
  }, [formik.values.partner_residingCountry]);

  useEffect(() => {
    const fetchCity = async () => {
      if (formik.values.partner_residingState.length > 0) {
        try {
          const response = await getMultipleCity({ids:formik.values.partner_residingState});
          if (response.status === 200 || response.status === 201) {
            setCities(response.data);
          }
        } catch (error) {
          toast.error(error);
        }
      }
    };
    fetchCity();
  }, [formik.values.partner_residingState]);
  return (
    <div className="col-lg-9 col-12">
      <Card className="editProfileBlock">
        <CardHeader
          avatar={<ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
          title="Partner's Education and Profession"
          subheader="Update your partner's education and profession details to find suitable matches"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <Autocomplete
                  multiple
                  className='mb-3'
                  options={partnerEducation}
                  getOptionLabel={(option) => option.education}
                  value={partnerEducation.filter(edu => formik.values.Partner_education.includes(String(edu.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('Partner_education', newValue.map((item) => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Education"
                      variant="outlined"
                      error={formik.touched.Partner_education && Boolean(formik.errors.Partner_education)}
                      helperText={formik.touched.Partner_education && formik.errors.Partner_education}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.education}
                        onDelete={() => formik.setFieldValue('Partner_education', formik.values.Partner_education.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={partnerOccupation}
                  className='mb-3'
                  getOptionLabel={(option) => option.occupation}
                  value={partnerOccupation.filter(occ => formik.values.partner_occupation.includes(String(occ.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partner_occupation', newValue.map((item) => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Profession"
                      variant="outlined"
                      error={formik.touched.partner_occupation && Boolean(formik.errors.partner_occupation)}
                      helperText={formik.touched.partner_occupation && formik.errors.partner_occupation}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.occupation}
                        onDelete={() => formik.setFieldValue('partner_occupation', formik.values.partner_occupation.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />

              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Partner Income"
                  variant="outlined"
                  className="mb-3"
                  name="partnerIncome"
                  value={formik.values.partnerIncome}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partnerIncome && Boolean(formik.errors.partnerIncome)}
                  helperText={formik.touched.partnerIncome && formik.errors.partnerIncome}
                >
                  <MenuItem value="">Select Income</MenuItem>
                  {income.map((income) => (
                    <MenuItem key={income.tbl_income_id} value={income.tbl_income_id}>{income.income_type}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={countries}
                  getOptionLabel={(option) => option.country}
                  value={countries.filter(rel => formik.values.partner_residingCountry.includes(String(rel.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partner_residingCountry', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Residing Country"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partner_residingCountry && Boolean(formik.errors.partner_residingCountry)}
                      helperText={formik.touched.partner_residingCountry && formik.errors.partner_residingCountry}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option?.country || ''} // Safeguard against undefined option
                        onDelete={() =>
                          formik.setFieldValue('partner_residingCountry', formik.values.partner_residingCountry.filter(id => id !== String(option.id)))
                        }
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={states}
                  getOptionLabel={(option) => option.state_name}
                  value={states.filter(rel => formik.values.partner_residingState.includes(String(rel.state_id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partner_residingState', newValue.map(item => String(item.state_id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Residing State"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partner_residingState && Boolean(formik.errors.partner_residingState)}
                      helperText={formik.touched.partner_residingState && formik.errors.partner_residingState}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.state_name}
                        onDelete={() => formik.setFieldValue('partner_residingState', formik.values.partner_residingState.filter(id => id !== String(option.state_id)))}
                        {...getTagProps({ index })}
                        key={option.state_id}
                      />
                    ))
                  }
                />
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={cities}
                  getOptionLabel={(option) => option.city}
                  value={cities.filter(caste => formik.values.partner_residingCity.includes(String(caste.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partner_residingCity', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Residing City"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partner_residingCity && Boolean(formik.errors.partner_residingCity)}
                      helperText={formik.touched.partner_residingCity && formik.errors.partner_residingCity}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.city}
                        onDelete={() => formik.setFieldValue('partner_residingCity', formik.values.partner_residingCity.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>
            </div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
              <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
              </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>
      <ToastContainer/>
    </div>
  );

}
